<div class="error404">
  <div class="image-404">
    <img src="/assets/images/404ErrorPage.svg" alt="download-icon" />
  </div>
  <div class="text">Not Found</div>
  <div class="button-go">
    <button [routerLink]="['/']">Go back</button>
  </div>
</div>
